import React, { Component } from 'react';

import IntroWithWatermark from '../global/IntroWithWatermark';
import NextSectionArrow from '../chapter/NextSectionArrow';

import style from './EraHero.module.scss';
import { Observer } from 'react-lazy';

import { TweenLite, TimelineLite } from 'gsap';

import { CSSPlugin } from 'gsap/CSSPlugin';

const plugins = [CSSPlugin];
let SplitText;

class EraHero extends Component {
  state = {
    entered: false,
  };
  registerTitle = el => (this.titleRef = el);

  registerWatermark = el => (this.watermarkRef = el);

  animateInView = () => {
    const tl = new TimelineLite({
      onComplete: () => {},
    });

    this.imageRef &&
      tl.to(
        this.imageRef,
        5,
        { scale: 1, autoAlpha: 1, ease: Quad.easeOut },
        0
      );

    this.watermarkRef &&
      tl.to(this.watermarkRef, 0.85, { y: '0%', ease: Quad.easeOut }, 0);

    this.ruleRef &&
      tl.to(this.ruleRef, 1.15, { scaleX: 1, ease: Quad.easeOut }, 0.1);

    this.splitTitle &&
      tl.staggerTo(
        this.splitTitle.words,
        0.5,
        { y: '0%', ease: Quad.easeOut },
        0.05,
        0.75
      );

    this.splitDesc &&
      tl.staggerTo(
        this.splitDesc.words,
        0.5,
        { y: '0%', ease: Quad.easeOut },
        0.05,
        0.75
      );
  };

  handleInView = event => {
    if (event.isIntersecting && !this.state.entered) {
      this.setState({ entered: !this.state.entered });
      this.animateInView();
    }
  };

  wrap = splitText => {
    splitText.forEach(splitElement => {
      let element;
      if (typeof document !== 'undefined') {
        element = document.createElement('span');
      }
      if (splitElement.parentNode.tagName === 'STRONG') {
        splitElement.parentNode.className = style.maskDownWrapper;
      } else {
        element.className = style.maskDownWrapper;
        splitElement.parentNode.insertBefore(element, splitElement);
        element.appendChild(splitElement);
      }
    });
  };

  componentDidMount() {
    if (typeof window !== undefined && typeof document !== undefined) {
      SplitText = require('../../lib/SplitText');
    }
    if (typeof window !== undefined && typeof document !== undefined) {
      this.splitDesc =
        this.descRef &&
        new SplitText(this.descRef, {
          type: 'words',
          wordsClass: 'maskDownTitle',
        });

      this.splitTitle =
        this.titleRef &&
        new SplitText(this.titleRef, {
          type: 'words',
          wordsClass: 'maskDownTitle',
        });

      this.watermarkRef && this.wrap([this.watermarkRef]);
      this.splitTitle && this.wrap(this.splitTitle.words);
      this.splitDesc && this.wrap(this.splitDesc.words);

      this.ruleRef && TweenLite.set(this.ruleRef, { scaleX: 0 });
      this.imageRef && TweenLite.set(this.imageRef, { scale: 1.2 });
      this.watermarkRef && TweenLite.set(this.watermarkRef, { y: '100%' });
      // TweenLite.set(this.descRef, { css: { maxWidth: 'initial' } });
      this.splitDesc && TweenLite.set(this.splitDesc.words, { y: '100%' });
      this.splitTitle && TweenLite.set(this.splitTitle.words, { y: '100%' });
    }
  }

  render() {
    const {
      starting_year,
      ending_year,
      image,
      short_description,
      title,
      watermark,
      last,
      goToAbout,
    } = this.props;

    return (
      <div
        className={`timeline-start ${style.eraHero} ${
          last ? style.lastHero : ''
        }`}
        id={`years${starting_year}`}
      >
        <img
          ref={el => (this.imageRef = el)}
          src={image.url}
          alt={image.alt}
          className={style.eraHeroImage}
        />
        <span className={style.overlay} />
        <Observer
          onChange={this.handleInView}
          threshold={[0.85]}
          triggerOnce={true}
        >
          <div className={style.eraHeroWrapper}>
            <IntroWithWatermark
              title={title}
              registerTitle={this.registerTitle}
              registerWatermark={
                this.props.watermark ? this.registerWatermark : false
              }
              watermark={watermark}
            />
            <div ref={el => (this.ruleRef = el)} className={style.rule} />
            <div>
              <p
                ref={el => (this.descRef = el)}
                className={style.eraDescription}
                dangerouslySetInnerHTML={{
                  __html: short_description,
                }}
              />
              {last && (
                <NextSectionArrow
                  isTimeline
                  goToNextSection={goToAbout}
                  arrowStyle={'white'}
                  isLastSection={this.state.entered}
                />
              )}
            </div>
          </div>
        </Observer>
      </div>
    );
  }
}

export default EraHero;



// WEBPACK FOOTER //
// ./src/components/timeline/EraHero.js